function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import ContactSalesHubspotFormConfig from "../side-by-side-hubspot-form/components/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Hubspot Dynamic Form",
    fields: _object_spread({
        formId: {
            type: FIELD_TYPES.TEXT,
            label: "Form ID"
        },
        formWidth: {
            type: FIELD_TYPES.TEXT,
            label: "Form Width (specify units: px/%)"
        },
        urlToRedirectAfterSubmission: {
            type: FIELD_TYPES.TEXT,
            label: "URL to redirect after submission (In Webflow)"
        },
        backgroundColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Background Color",
            defaultValue: "white"
        },
        textColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Text Color",
            defaultValue: "black"
        },
        textSize: {
            type: FIELD_TYPES.TEXT,
            label: "text Size",
            defaultValue: "0.875rem"
        },
        ctaButtonColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "CTA Button Color",
            defaultValue: "workos-iris"
        },
        ctaTextColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "CTA Text Color",
            defaultValue: "white"
        },
        formShadow: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Form with shadow",
            defaultValue: true
        }
    }, ContactSalesHubspotFormConfig)
};
